<pre>{{ '{' }} "status": "ok" {{'}'}}</pre>
